// extracted by mini-css-extract-plugin
export default {"errorTitle":"dwtAdictE1ftFASok51O","errorContainer":"j84bcXnN_RaHkxIArxfU"};